import { render, staticRenderFns } from "./SettingsCopyrightsV2.vue?vue&type=template&id=91d57fdc&scoped=true"
import script from "./SettingsCopyrightsV2.vue?vue&type=script&lang=js"
export * from "./SettingsCopyrightsV2.vue?vue&type=script&lang=js"
import style0 from "./SettingsCopyrightsV2.vue?vue&type=style&index=0&id=91d57fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d57fdc",
  null
  
)

export default component.exports